import React from 'react';

import Navbar from './Navbar';
import Hero from './Hero';
import Product from './Product';

const Header = ({ heading, description, list, image, bgImage, altText, template }) => {
  
  return (
    <header>
      <Navbar />
      {(template === 1)
      ?
      // <Product 
      //   heading={heading}
      //   description={description}
      //   list={list}
      //   image={image}
      //   bgImage={bgImage}
      //   altText={altText}
      // />
      null
      :
      <Hero 
        heading={heading}
        description={description}
        list={list}
        image={image}
        bgImage={bgImage}
        altText={altText}      
      />
      }
    </header>
  );
}

export default Header;